type P = { className?: string };

const S = ({ children, className, fill = 'none' }: P & { children: React.ReactNode; fill?: string }) => (
  <svg
    viewBox="0 0 24 24"
    className={className}
    fill={fill}
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {children}
  </svg>
);

export const IconPrev = ({ className }: P) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor">
    <path d="M6 5a1 1 0 0 1 2 0v14a1 1 0 0 1-2 0V5Z" />
    <path d="M19 5.5v13a1 1 0 0 1-1.55.83l-9-6.5a1 1 0 0 1 0-1.66l9-6.5A1 1 0 0 1 19 5.5Z" />
  </svg>
);

export const IconNext = ({ className }: P) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor">
    <path d="M18 5a1 1 0 0 0-2 0v14a1 1 0 0 0 2 0V5Z" />
    <path d="M5 5.5v13a1 1 0 0 0 1.55.83l9-6.5a1 1 0 0 0 0-1.66l-9-6.5A1 1 0 0 0 5 5.5Z" />
  </svg>
);

export const IconPlay = ({ className }: P) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor">
    <path d="M7 5.5v13a1 1 0 0 0 1.53.85l10.5-6.5a1 1 0 0 0 0-1.7L8.53 4.65A1 1 0 0 0 7 5.5Z" />
  </svg>
);

export const IconPause = ({ className }: P) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor">
    <rect x="6" y="5" width="4" height="14" rx="1.3" />
    <rect x="14" y="5" width="4" height="14" rx="1.3" />
  </svg>
);

export const IconStop = ({ className }: P) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor">
    <rect x="6" y="6" width="12" height="12" rx="2" />
  </svg>
);

export const IconAirplay = ({ className }: P) => (
  <S className={className}>
    <path d="M5 17H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-1" />
    <path d="M12 15l5 6H7l5-6Z" fill="currentColor" stroke="none" />
  </S>
);

export const IconSliders = ({ className }: P) => (
  <S className={className}>
    <line x1="4" y1="8" x2="20" y2="8" />
    <line x1="4" y1="16" x2="20" y2="16" />
    <circle cx="9" cy="8" r="2.2" fill="currentColor" stroke="none" />
    <circle cx="15" cy="16" r="2.2" fill="currentColor" stroke="none" />
  </S>
);

export const IconVolume = ({ className }: P) => (
  <S className={className}>
    <path d="M11 5 6 9H3v6h3l5 4V5Z" fill="currentColor" stroke="none" />
    <path d="M15.5 8.5a5 5 0 0 1 0 7" />
    <path d="M18.5 6a8 8 0 0 1 0 12" />
  </S>
);

export const IconMore = ({ className }: P) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor">
    <circle cx="5" cy="12" r="1.8" />
    <circle cx="12" cy="12" r="1.8" />
    <circle cx="19" cy="12" r="1.8" />
  </svg>
);

export const IconList = ({ className }: P) => (
  <S className={className}>
    <line x1="8" y1="7" x2="20" y2="7" />
    <line x1="8" y1="12" x2="20" y2="12" />
    <line x1="8" y1="17" x2="20" y2="17" />
    <circle cx="4" cy="7" r="1" fill="currentColor" stroke="none" />
    <circle cx="4" cy="12" r="1" fill="currentColor" stroke="none" />
    <circle cx="4" cy="17" r="1" fill="currentColor" stroke="none" />
  </S>
);

export const IconCode = ({ className }: P) => (
  <S className={className}>
    <path d="M9 8l-4 4 4 4" />
    <path d="M15 8l4 4-4 4" />
    <path d="M13.5 6l-3 12" />
  </S>
);

export const IconExpand = ({ className }: P) => (
  <S className={className}>
    <path d="M9 4H4v5M15 4h5v5M9 20H4v-5M15 20h5v-5" />
  </S>
);

export const IconClose = ({ className }: P) => (
  <S className={className}>
    <line x1="6" y1="6" x2="18" y2="18" />
    <line x1="18" y1="6" x2="6" y2="18" />
  </S>
);

export const IconPlus = ({ className }: P) => (
  <S className={className}>
    <path d="M12 5v14M5 12h14" />
  </S>
);

export const IconHeart = ({ className, filled }: P & { filled?: boolean }) => (
  <svg
    viewBox="0 0 24 24"
    className={className}
    fill={filled ? 'currentColor' : 'none'}
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
  </svg>
);

export const IconGear = ({ className }: P) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" fillRule="evenodd" clipRule="evenodd">
    <path d="M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z" />
  </svg>
);
